import { EmptyPhoneNumber } from "@/constants";
import { emptyStringToUndefined, z } from "@utils/zod";

import type { IPhoneNumber } from "@interfaces";
import type { IShapeOfField } from "@utils/zod";

export interface ILoginFormSchema {
  phone: IPhoneNumber;
  password: string;
}

export const loginFormInitialValues: ILoginFormSchema = {
  phone: EmptyPhoneNumber,
  password: "",
};

export const loginFormValidationSchema = z.object<
  IShapeOfField<ILoginFormSchema>
>({
  phone: z.phone(),
  password: emptyStringToUndefined(z.string()),
});
